import React, { Dispatch, SetStateAction } from 'react'
import { IQuestionList } from '../../classes/QuestionsList';
import { ISurvey } from '../../classes/Survey';
import ReturnBar from '../generic/ReturnBar/ReturnBar';
import { useNavigate } from 'react-router-dom';

interface Props {
  survey: ISurvey;
  questionLists: IQuestionList[],
  setViewQuestionsData: Dispatch<SetStateAction<boolean>>,
}

const QuestionsData = (props: Props) => {
  const navigate = useNavigate();
  console.log("Question data gg: ", props);
  let indexEnd = 1;
  const getIndexEnd = (n: number): void => {
    indexEnd = n;
  }
  
  // Check if this is a custom survey (not a template survey)
  const templateSurveys = ["Employee Burnout", "Employee Engagement", "Job Satisfaction Survey", "eNPS"];
  const isCustomSurvey = !templateSurveys.includes(props.survey.title);
  
  console.log("[QuestionsData] Survey title:", props.survey.title);
  console.log("[QuestionsData] Is custom survey:", isCustomSurvey);
  console.log("[QuestionsData] Template surveys:", templateSurveys);
  
  // For custom surveys, navigate to surveys list. For template surveys, go back to overview
  const handleBackNavigation = () => {
    console.log("[QuestionsData] Back clicked - isCustomSurvey:", isCustomSurvey);
    if (isCustomSurvey) {
      console.log("[QuestionsData] Navigating to /surveys");
      navigate('/surveys');
    } else {
      console.log("[QuestionsData] Setting viewQuestionsData to false");
      props.setViewQuestionsData(false);
    }
  };
  
  return (
    <>
      <ReturnBar 
        title={props.survey.title} 
        onBackClick={handleBackNavigation}
      />
      <div>
        {
          props.questionLists.map((questionList, index) =>
            <div key={index}>
              {
                questionList.render({
                  questions: questionList.questions,
                  indexStart: indexEnd,
                  getIndexEnd: getIndexEnd
                })
              }
            </div>
          )
        }
      </div>
    </>
  )
}

export default QuestionsData;